import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Box, InputAdornment, Pagination, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import CardCourse from "../CardCourse/CardCourse";
import "./favorites.scss";
import Empty from "../Empty/Empty";

const Favorites = ({
  favorites,
  favoritesNumber,
  setFilterFavorites,
  filterFavorites,
  loading,
}: any) => {
  const handleChangePage = (_: any, number: number) => {
    if (Math.abs(favoritesNumber - (number - 1) * 12) < 12) {
      setFilterFavorites({
        ...filterFavorites,
        page: [number - 1],
        limit: [Math.abs(favoritesNumber - (number - 1) * 12)],
      });
    } else {
      setFilterFavorites({
        ...filterFavorites,
        page: [number - 1],
        limit: [12],
      });
    }
  };

  const handleChangeSearch = (e: string) => {
    setFilterFavorites({ ...filterFavorites, search: [e] });
  };

  const Content = () => {
    if (loading) {
      return (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            margin: "186px auto",
          }}>
          <CircularProgress />
        </Box>
      );
    } else {
      if (favoritesNumber) {
        return (
          <Box className={"favorites-cards"}>
            {favorites.map((el: any) => {
              return <CardCourse key={el?.id} info={el} />;
            })}
          </Box>
        );
      } else {
        return (
          <Empty
            title={"У вас пока нет таких курсов"}
            subtitle={""}
            btn={false}
          />
        );
      }
    }
  };
  return (
    <Box>
      <Box className={"favorites-action"}>
        <Box className={"favorites-search-wrapper"}>
          <TextField
            className={"favorites-search"}
            placeholder="Поиск по ключевым словам"
            value={filterFavorites.search[0]}
            size="small"
            onChange={(e) => handleChangeSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            variant="outlined"
          />
        </Box>
      </Box>

      <Content />
      {loading ? null : (
        <Box className={"pagination-wrapper"}>
          <Pagination
            count={Math.ceil(favoritesNumber / 12)}
            page={+filterFavorites.page + 1}
            shape="rounded"
            onChange={handleChangePage}
          />
        </Box>
      )}
    </Box>
  );
};

export default Favorites;
